<template>
    <ion-page>
        <ion-content>
            <div class="desktop-panel">
                <div style="width: 100%; height: 800px; position: relative">
                    <AuroraAnimation />
                </div>
                <div class="auth-intro-header">
                    <h1>{{ $t("auth.forgot-password.new-password") }}</h1>
                </div>

                <div class="actions">
                    <form @submit.prevent="handleResetPassword">
                        <ion-input
                            id="password"
                            v-model="form.password"
                            name="password"
                            :placeholder="
                                $t('auth.forgot-password.new-password')
                            "
                            required
                            type="password"
                        />
                        <ion-input
                            id="password_confirmation"
                            v-model="form.password_confirmation"
                            name="password_confirmation"
                            :placeholder="
                                $t('auth.forgot-password.repeat-new-password')
                            "
                            required
                            type="password"
                        />
                        <ion-button class="btn" expand="block" type="submit">
                            {{ $t("auth.forgot-password.cta-set") }}
                        </ion-button>

                        <div class="bottom-action">
                            {{ $t("auth.set-new-password.remember") }}
                            <br />
                            <span
                                class="primary"
                                @click="
                                    () => router.push({ name: 'auth.login' })
                                "
                            >
                                {{ $t("auth.set-new-password.back-to-login") }}
                            </span>
                        </div>
                    </form>
                </div>
            </div>
            <floating-back-button />
        </ion-content>
    </ion-page>
</template>

<script lang="ts" setup>
    import useAuth from "@/componentables/auth";
    import { IonPage, IonContent, IonInput, IonButton } from "@ionic/vue";
    import { useRouter } from "vue-router";
    import { ref } from "vue";
    import FloatingBackButton from "@/components/FloatingBackButton.vue";
    import AuroraAnimation from "@/components/animated/AuroraAnimation.vue";

    const router = useRouter();
    const auth = useAuth();

    const form = ref({
        password: "",
        password_confirmation: "",
        token: router.currentRoute.value.query.token as string,
        email: router.currentRoute.value.query.email as string,
    });

    async function handleResetPassword() {
        await auth.resetPassword(form.value);

        router.push({ name: "auth.login" });
    }
</script>

<style lang="scss" scoped>
    @use "@/assets/scss/specific/auth" as *;

    .auth-intro-header {
        position: absolute;
        top: 5%;
        left: 0;
        right: 0;
        padding-bottom: 88px;

        h1 {
            font-size: vw(32px);
            text-align: center;
            font-weight: 600;
        }
    }

    .actions {
        form {
            ion-input {
                margin-bottom: 8px;
                border: 1px solid var(--color-black-alpha-10);
            }

            .btn {
                margin-bottom: 16px;
            }

            .bottom-action {
                padding-top: vw(24px);
                font-size: 12px;
                font-weight: 600;
                line-height: 120%;
                text-align: center;
                color: var(--color-black-alpha-50);
            }
        }
    }
</style>
